module.exports = __webpack_public_path__ + "img/subscription-paused.4ebd01c.png";